import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IInvoice, Invoice } from '@shared/models/invoice';
import { InvoiceApiService } from '../../@shared/services';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService {
    invoice: IInvoice;
    invoiceOnChanged: BehaviorSubject<Invoice> = new BehaviorSubject(new Invoice());

    constructor(
        private _invoiceApiService: InvoiceApiService
    ) {
    }

    getInvoice(id): Observable<Invoice> {
        return this._invoiceApiService.getOne(id);
    }

    updateInvoice(invoice: Invoice): Observable<number> {
        return this._invoiceApiService.update(invoice);
    }

    saveInvoice(invoice: any/*Invoice*/): Observable<number> {
        return this._invoiceApiService.add(invoice);
    }

    getInvoiceTestPDF(invoice: any/*Invoice*/): Observable<number> {
        return this._invoiceApiService.getInvoiceTestPDF(invoice);
    }
}
